import {
    ProductSearchViewModel,
    ProductSearchViewModelGenericSearchResultViewModel as ProductSearchResult
} from '@models/api-search.models';
import { RelewiseRetailMediaPlacement } from '@core/services/relewise/relewise-tracking.model';

/**
 * This will merge the retail media products with the products from the search result but giving priority to the retail media products
 * if the retail media products it's within the maxOf products value, we will show those, otherwise we will do the difference between
 * them to show the rest of the products from the search
 * @param value
 * @param placement
 * @param maxOfProducts
 */
export const mergeWithRetailMediaHelper = (
    value: ProductSearchResult,
    placement: RelewiseRetailMediaPlacement,
    maxOfProducts: number = 3
): ProductSearchViewModel[] => {
    const retailMediaPlacement = value.retailMediaProducts?.placements?.find(p => p.placementKey === placement);
    const retailMediaProducts = (retailMediaPlacement?.data ?? []).slice(0, maxOfProducts);

    // if we have enough products on retail media, we don't need to merge it
    if (retailMediaProducts.length >= maxOfProducts) {
        return retailMediaProducts;
    }

    const diff = maxOfProducts - retailMediaProducts.length;
    const products = (value?.products ?? []).slice(0, diff);
    return [...retailMediaProducts, ...products];
};
